import React from 'react';
import { Table, Row, Col, Button } from 'react-bootstrap';

import FieldGroup from './common/FieldGroup.jsx';
import DropDownInput from './common/DropDownInput.jsx';

export default class MaintenanceOrderDetailEditComponent extends React.Component {

	componentWillMount() {
		this.props.findMaintenanceOrderDetails(this.props.orderDetail.get('orderId'));
	}

	componentDidMount() {
	}


	toCatDropDownOptions(cats) {
		let ret = [];
		cats.map((item, index) => {
			ret.push({ value: index, label: item.description });
		});
		return ret;
	}

	toSetDropDownOptions(category) {
		let ret = [];
		let checksets = category.checkSets;

		checksets.map((item, index) => {
			ret.push({ value: index, label: item.description });
		});
		return ret;
	}

	pricing(checkSet) {
		if (checkSet.pricing === "BY_SUIT") {
			return "-(件)-";
		}
		if (checkSet.pricing === "BY_ABUNDANCE") {
			return "-(量)-";
		}
		return '';
	}


	isPositiveNature(input) {
		let re = new RegExp("^\\d+$");
		return re.test(input);
	}

	isPositiveDouble(input) {
		let re = new RegExp("^\\d+\\.{0,1}\\d{0,15}$");
		return re.test(input);
	}

	isEmpty(input) {
		if (input === undefined || input === '' || input === null) {
			return true;
		}
		return false;
	}

	deleteOrderDetail(detail, orderId) {
		let ret = confirm('確定移除: ' + detail.category + '-' + detail.checkSet + '(' + detail.quantity + ')?');
		if (ret) {
			this.props.deleteMaintenanceOrderDetail(detail.id, orderId);
		}
	}

	createOrderDetail() {
		//check required;
		if (this.isEmpty(this.props.orderDetail.get('category')) ||
			this.isEmpty(this.props.orderDetail.get('checkSet')) ||
			this.isEmpty(this.props.orderDetail.get('sPrice')) ||
			this.isEmpty(this.props.orderDetail.get('sQuantity'))) {
			alert('清洗維修大類,細類,價格,訂貨數量為必填欄位')
		}
		else if (!this.isPositiveDouble(this.props.orderDetail.get('sPrice'))) {
			alert('價格必須是數字, 且為正數')
		}
		else if (!this.isPositiveNature(this.props.orderDetail.get('sQuantity'))) {
			alert('訂貨數量為必須是正整數')
		}
		else {
			this.props.newOrderDetail(
				this.props.orderDetail.get('orderId'),
				this.props.orderDetail.get('category'),
				this.props.orderDetail.get('checkSet'),
				this.props.orderDetail.get('sPrice'),
				this.props.orderDetail.get('sQuantity'));
		}
	}

	render() {
		return (
			<div>
				<Row>
					<Col xs={12} sm={12} md={12}>
						{
							<div style={{ width: '100%' }}><span hidden> MaintenanceOrderDetailEditComponent </span>
								<h4 className="control-label" style={{ marginBottom: 20 }}>訂單明細</h4>
								<Table bordered condensed hover style={{ width: '100%' }} >
									<thead>
										<tr>
											<th width="5%">編號</th>
											<th width="40%">產品名</th>
											<th width="25%">價格</th>
											<th width="25%">訂購數量</th>
											<th width="5%">取消</th>
										</tr>
									</thead>
									<tbody>
										{
											this.props.orderDetail.get('details').map((item, index) =>
												<tr key={index}>
													<td style={{ textAlign: 'center' }}>{index + 1}</td>
													<td>{item.category}-{item.checkSet}</td>
													<td style={{ textAlign: 'right', paddingRight: '25px' }}>{item.price}</td>
													<td style={{ textAlign: 'right', paddingRight: '25px' }}>{item.quantity}</td>
													<td style={{ textAlign: 'center' }}>
														<span className="glyphicon glyphicon-trash" style={{ marginRight: 10, color: '#a94442', cursor: 'pointer' }}
															onClick={(event) => { this.deleteOrderDetail(item, this.props.orderDetail.get('orderId')) }} />
													</td>
												</tr>
											)
										}
									</tbody>
								</Table>
							</div>
						}
					</Col>
				</Row>
				<Row>
					<Col xs={12} sm={12} md={12}>
						{/*<Alert bsStyle={this.props.alertStyle}>
							{this.props.alertMessage}
						</Alert>*/}
						<h4 className="control-label" style={{ marginBottom: 20 }}>訂單編號: {this.props.orderDetail.get('orderId')}</h4>
						<DropDownInput id="category"
							label="清洗維修大類"
							required="true"
							options={this.toCatDropDownOptions(this.props.categories)}
							selected={[{ label: this.props.orderDetail.get('category'), id: this.props.orderDetail.get('catId') }]}
							onChange={(id, value, label) => {
								this.props.selectDetailCategory(value, label);
							}}
						/>

						<DropDownInput id="checkSet"
							label="清洗維修細類"
							required="true"
							options={this.toSetDropDownOptions(this.props.categories[this.props.orderDetail.get('catId')])}
							selected={[]}
							onChange={(id, value, label) => {
								this.props.selectDetailCheckSet(value, label);
							}}
						/>

						<FieldGroup
							id="sPrice"
							type="number"
							label="價格"
							value={this.props.orderDetail.get('sPrice')}
							placeholder=""
							required="true"
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
						/>

						<FieldGroup
							id="sQuantity"
							type="number"
							label="訂貨數量"
							value={this.props.orderDetail.get('sQuantity')}
							placeholder=""
							required="true"
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.orderDetailValidation.get('sQuantity')}
						/>
					</Col>
				</Row>
				<table style={{ width: '90%' }}>
					<tbody>
						<tr>
							<td style={{ textAlign: 'right' }} >
								<Button onClick={(event) => { this.createOrderDetail(); }} bsStyle="info">
									確認採購明細
								</Button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		)
	}
};


// WEBPACK FOOTER //
// ./src/components/MaintenanceOrderDetailEditComponent.jsx